import { useEffect, useState } from "react";
import api from "@/lib/api";

const RUOLI = [
  { k: "responsabile", label: "Responsabile" },
  { k: "controllore", label: "Controllore" },
  { k: "dpo", label: "DPO" },
  { k: "controllore_backup", label: "Controllore Backup" },
  { k: "system_administrator", label: "System Administrator" },
];

const EMPTY = {
  ruolo: "responsabile", docente_id: null,
  cognome: "", nome: "", data_nascita: "", luogo_nascita: "",
  telefono: "", email: "", indirizzo: "",
};

export default function PrivacyIncaricatiPage() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const carica = async () => {
    setLoading(true);
    try {
      const r = await api.get("/privacy/incaricati");
      setItems(r.data.items || []);
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  const salva = async () => {
    try {
      const payload = { ...editing };
      if (editing._id) {
        await api.put(`/privacy/incaricati/${editing._id}`, payload);
      } else {
        await api.post("/privacy/incaricati", payload);
      }
      setEditing(null);
      await carica();
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
  };

  const elimina = async (it) => {
    if (!window.confirm(`Eliminare ${it.cognome} ${it.nome}?`)) return;
    try {
      await api.delete(`/privacy/incaricati/${it._id}`);
      await carica();
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
  };

  const ruoloLabel = (k) => RUOLI.find(r => r.k === k)?.label || k;

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        <h2 style={{ color: "#37474f", fontSize: 18, margin: 0 }}>👥 Incaricati · {items.length}</h2>
        <button onClick={() => setEditing({ ...EMPTY })} data-testid="priv-inc-new"
          style={{ marginLeft: "auto", padding: "7px 16px", background: "#37474f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          ➕ Nuovo incaricato
        </button>
      </div>
      {err && <div style={{ padding: 10, background: "#fff0f0", color: "#c00", fontSize: 12, marginBottom: 10 }}>{err} <button onClick={() => setErr(null)} style={{ float: "right", background: "none", border: "none", cursor: "pointer", color: "#c00", fontWeight: 700 }}>✕</button></div>}
      <div style={{ background: "white", border: "1px solid #ccc" }}>
        <table className="sw-table sw-table-compact" style={{ fontSize: 11 }}>
          <thead style={{ background: "#37474f", color: "white" }}>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th style={{ width: 150 }}>RUOLO</th>
              <th style={{ minWidth: 200 }}>NOMINATIVO</th>
              <th style={{ width: 100 }}>DATA NASCITA</th>
              <th style={{ width: 140 }}>LUOGO NASCITA</th>
              <th style={{ width: 130 }}>TELEFONO</th>
              <th style={{ width: 200 }}>EMAIL</th>
              <th style={{ width: 100, textAlign: "center" }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={8} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessun incaricato. Clicca <b>+ Nuovo incaricato</b>.</td></tr>
            )}
            {items.map((it, i) => (
              <tr key={it._id} data-testid={`priv-inc-row-${i}`}>
                <td style={{ textAlign: "center", color: "#888", fontFamily: "Consolas, monospace" }}>{i + 1}</td>
                <td style={{ fontWeight: 700, color: "#37474f" }}>{ruoloLabel(it.ruolo)}</td>
                <td style={{ fontWeight: 600 }}>{it.cognome} {it.nome}</td>
                <td>{it.data_nascita || "—"}</td>
                <td>{it.luogo_nascita || "—"}</td>
                <td>{it.telefono || "—"}</td>
                <td>{it.email || "—"}</td>
                <td style={{ textAlign: "center" }}>
                  <button onClick={() => setEditing({ ...it })} data-testid={`priv-inc-edit-${i}`}
                    style={{ background: "#1565c0", color: "white", border: "none", padding: "3px 8px", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 4 }}>✏</button>
                  <button onClick={() => elimina(it)} data-testid={`priv-inc-del-${i}`}
                    style={{ background: "#c62828", color: "white", border: "none", padding: "3px 8px", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && <EditModal editing={editing} setEditing={setEditing} onSave={salva} />}
    </div>
  );
}

function EditModal({ editing, setEditing, onSave }) {
  const setF = (k, v) => setEditing({ ...editing, [k]: v });
  return (
    <div onClick={() => setEditing(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "white", width: 620, borderRadius: 4, overflow: "hidden" }}>
        <div style={{ background: "#37474f", color: "white", padding: "12px 18px", fontWeight: 700, fontSize: 14, display: "flex", justifyContent: "space-between" }}>
          {editing._id ? "✏ Modifica Incaricato" : "➕ Nuovo Incaricato"}
          <button onClick={() => setEditing(null)} style={{ background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer" }}>✕</button>
        </div>
        <div style={{ padding: 18, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div style={{ gridColumn: "1 / span 2" }}>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>RUOLO *</label>
            <select value={editing.ruolo} onChange={e => setF("ruolo", e.target.value)} data-testid="priv-inc-m-ruolo"
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }}>
              {RUOLI.map(r => <option key={r.k} value={r.k}>{r.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>COGNOME *</label>
            <input value={editing.cognome || ""} onChange={e => setF("cognome", e.target.value)} data-testid="priv-inc-m-cog"
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
          <div>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>NOME *</label>
            <input value={editing.nome || ""} onChange={e => setF("nome", e.target.value)} data-testid="priv-inc-m-nom"
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
          <div>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>DATA NASCITA</label>
            <input type="date" value={editing.data_nascita || ""} onChange={e => setF("data_nascita", e.target.value)}
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
          <div>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>LUOGO NASCITA</label>
            <input value={editing.luogo_nascita || ""} onChange={e => setF("luogo_nascita", e.target.value)}
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
          <div>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>TELEFONO</label>
            <input value={editing.telefono || ""} onChange={e => setF("telefono", e.target.value)}
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
          <div>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>EMAIL</label>
            <input value={editing.email || ""} onChange={e => setF("email", e.target.value)}
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
          <div style={{ gridColumn: "1 / span 2" }}>
            <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>INDIRIZZO</label>
            <input value={editing.indirizzo || ""} onChange={e => setF("indirizzo", e.target.value)}
              style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
          </div>
        </div>
        <div style={{ padding: "10px 18px", borderTop: "1px solid #eee", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button onClick={() => setEditing(null)} style={{ padding: "6px 14px", background: "white", color: "#666", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
          <button onClick={onSave} data-testid="priv-inc-save"
            style={{ padding: "6px 18px", background: "#37474f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>💾 Salva</button>
        </div>
      </div>
    </div>
  );
}
